// @flow strict

import { Avatar } from '@material-ui/core';
import {  ChatOutlined, SendOutlined, ShareOutlined, ThumbUpOutlined } from '@material-ui/icons';
import  React,{forwardRef} from 'react';
import InputOptions from './InputOptions';
import './Post.css'

const  Post = forwardRef(({name,description,message,photoUrl}, ref) => {
    const [post,SetPost] = React.useState([])
    return (
        <div ref={ref} className='post'>
           <div className='post__header'>
               <Avatar src={photoUrl}>{name[0]}</Avatar>
               <div className='post__info'>
                   <h2>{name}</h2>
                   <p>{description}</p>
               </div>

           </div>

           <div className='post__body'>
               <p>{message}</p>

           </div>

           <div className='post__buttons' >
               <InputOptions Icon={ThumbUpOutlined} title="Like" color="grey" />
               <InputOptions Icon={ChatOutlined} title="Comment" color="grey" />
               <InputOptions Icon={ShareOutlined} title="Share" color="grey" />
               <InputOptions Icon={SendOutlined} title="Send" color="grey" />
           </div>
            
        </div>
    );
});

export default Post;